import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';

class PetLabelInfo extends React.Component
{
  handleLabelSelected = (petLabel) => {
    const price = this.refs[petLabel.Id].value;
    this.props.onSelected(petLabel, price);
  }




  render() {
    const {petLabel, enabled} = this.props;



    let priceDefault = "";
    if(petLabel.Price !== '') {
      priceDefault = petLabel.Price;
    }

    return (
      <div className="col-lg-6 col-sm-12 col-pet">
        <div className="media">
          <div className="mr-3 align-self-start">
            <img src={petLabel.ImageUrl} alt={petLabel.Line1} />
          </div>
          <div className="media-body">
            <h5>{petLabel.Line1}</h5> 
            <h6>{petLabel.Line2}</h6>
            <h6>{petLabel.Line3} </h6>
            <div className="row plu-barcode no-gutters">
                <span className="plu">{petLabel.Line4}</span>
            </div>
            <input id={petLabel.Id} name={petLabel.Id} type="text" className="form-control" key={petLabel.Id+'a'+petLabel.ArticleMappingEntryID}
            placeholder={I18n.t('ENTER_PRICE_SEARCH_RESULTS')} defaultValue={priceDefault} ref={petLabel.Id} />
            <button type="button" onClick={() => {this.handleLabelSelected(petLabel);}} className="btn btn-primary" disabled={!enabled}>{I18n.t('ADD')}</button>
          </div>
        </div>
      </div>
    );
  }
}

PetLabelInfo.propTypes = {
  enabled: PropTypes.bool.isRequired,
	onSelected: PropTypes.func.isRequired,
	petLabel: PropTypes.object.isRequired
};

export default PetLabelInfo;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/PetLabelInfo.js
 **/